var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "loader-overlay",
      class: { "is-hidden": !_vm.visible },
      attrs: { id: "loader" }
    },
    [_vm._m(0)]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "lds-ripple" }, [_c("div"), _c("div")])
  }
]
render._withStripped = true

export { render, staticRenderFns }